module.exports = __webpack_public_path__ + "static/media/upcoming_game_2.002f8b6c.png";